import * as bpac from './bpac.js' 

export const preview = async (guest, url, path) => {
  //const DATA_FOLDER = "C:\\Users\\ivan\\Desktop\\MyTemplate.lbx";
  const DATA_FOLDER = path + "\\MyTemplate.lbx"
  try {
    const objDoc = await bpac.IDocument
    const ret = await objDoc.Open(DATA_FOLDER)


    if(ret===true){
      const objCompany = await objDoc.GetObject('objCompany')
      objCompany.Text = guest.company
      const objName = await objDoc.GetObject('objName')
      objName.Text = guest.name
      const objQrCode = await objDoc.GetObject('objQrCode')
      objQrCode.Text = `${url}/addtogroup/${guest.id}`
      const objPosition = await objDoc.GetObject('objPosition')
      objPosition.Text = guest.position
      const objVip = await objDoc.GetObject('objVip')
      if(guest.vip){
        objVip.Text = 'VIP'
      }else{
        objVip.Text = ' '
      }
      
      const image = await objDoc.GetImageData(4, 0, 500);
      objDoc.Close()
      return image
    }else{
      return 'error'
    }

  } catch (error) {
    console.log(error)
  }
}

export const printGuestTag = async (guest, url, path) => {

  const DATA_FOLDER = path + "\\MyTemplate.lbx"
  /*
  if(bpac.IsExtensionInstalled() === false){
    alert('Por favor, intale la extension de brother')
    const agent = window.navigator.userAgent.toLowerCase();
    const ischrome = (agent.indexOf('chrome') !== -1) && (agent.indexOf('edge') === -1)  && (agent.indexOf('opr') === -1)
    if(ischrome)
    window.open('https://chrome.google.com/webstore/detail/ilpghlfadkjifilabejhhijpfphfcfhb', '_blank');
    return;
	}
  */

  try {
    const objDoc = await bpac.IDocument
    const ret = await objDoc.Open(DATA_FOLDER)

    if(ret===true){
      const objCompany = await objDoc.GetObject('objCompany')
      objCompany.Text = guest.company
      const objName = await objDoc.GetObject('objName')
      objName.Text = guest.name
      const objQrCode = await objDoc.GetObject('objQrCode')
      objQrCode.Text = `${url}/addtogroup/${guest.id}`
      const objPosition = await objDoc.GetObject('objPosition')
      objPosition.Text = guest.position
      const objVip = await objDoc.GetObject('objVip')
      if(guest.vip){
        objVip.Text = 'VIP'
      }else{
        objVip.Text = ' '
      }
      
      objDoc.StartPrint('', 0)
      objDoc.PrintOut(1,0)
      objDoc.EndPrint()
  
      objDoc.Close()
    }else{
      return 'error'
    }

  } catch (error) {
    console.log(error)
  }
} 

export const printExhTag = async (exh, path) => {
  
  console.log(exh, path)
  
  const DATA_FOLDER = path + "\\Expositores.lbx"
  console.log(DATA_FOLDER)
  /*
  if(bpac.IsExtensionInstalled() === false){
    alert('Por favor, intale la extension de brother')
    const agent = window.navigator.userAgent.toLowerCase();
    const ischrome = (agent.indexOf('chrome') !== -1) && (agent.indexOf('edge') === -1)  && (agent.indexOf('opr') === -1)
    if(ischrome)
    window.open('https://chrome.google.com/webstore/detail/ilpghlfadkjifilabejhhijpfphfcfhb', '_blank');
    return;
	}
  */

  
  try {
    const objDoc = await bpac.IDocument
    const ret = await objDoc.Open(DATA_FOLDER)

    if(ret===true){
      const objCompany = await objDoc.GetObject('objCompany')
      objCompany.Text = exh.company
      const objName = await objDoc.GetObject('objName')
      objName.Text = exh.fullName
      const objPosition = await objDoc.GetObject('objPosition')
      objPosition.Text = exh.position
      
      objDoc.StartPrint('', 0)
      objDoc.PrintOut(1,0)
      objDoc.EndPrint()
  
      objDoc.Close()
    }else{
      return 'error'
    }

  } catch (error) {
    console.log(error)
  }
  
} 